import React, { useEffect, useState } from "react";
import { Bug } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["new", "in_progress", "resolved"];
const CLS = { new: "bg-rose-50 text-rose-700 border-rose-200", in_progress: "bg-amber-50 text-amber-700 border-amber-200", resolved: "bg-emerald-50 text-emerald-700 border-emerald-200" };

export default function AdminBugReports() {
  const [reports, setReports] = useState(null);
  useEffect(() => { api.get("/admin/bug-reports").then((r) => setReports(r.data)); }, []);

  const setStatus = async (id, status) => {
    await api.patch(`/admin/bug-reports/${id}`, { status });
    toast.success(`Marked ${status.replace("_", " ")}`);
    setReports((rs) => rs.map((r) => (r.id === id ? { ...r, status } : r)));
  };

  if (!reports) return <p className="text-slate-400 font-mono text-sm">Loading...</p>;
  if (reports.length === 0) {
    return (
      <div className="bg-white border border-dashed border-slate-300 rounded-xl p-16 text-center" data-testid="bug-reports-empty">
        <Bug className="mx-auto text-slate-300 mb-3" size={40} />
        <p className="text-slate-500">No bug reports yet.</p>
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="bug-reports-list">
      {reports.map((r) => (
        <div key={r.id} data-testid={`bug-report-${r.id}`} className="bg-white border border-slate-200 rounded-xl p-4">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <div className="flex items-center gap-2 text-xs font-mono text-slate-400">
              <span data-testid={`bug-status-${r.id}`} className={`uppercase tracking-wider border rounded-full px-2 py-0.5 ${CLS[r.status] || CLS.new}`}>{r.status.replace("_", " ")}</span>
              <span>{new Date(r.created_at).toLocaleString()}</span>
              {r.page && <span>· {r.page}</span>}
            </div>
            <div className="flex gap-1.5">
              {STATUSES.filter((s) => s !== r.status).map((s) => (
                <button key={s} data-testid={`bug-set-${s}-${r.id}`} onClick={() => setStatus(r.id, s)} className="text-xs px-2.5 py-1 rounded-full border border-slate-300 text-slate-600 hover:border-emerald-500 hover:text-emerald-700">Mark {s.replace("_", " ")}</button>
              ))}
            </div>
          </div>
          <p className="text-sm text-slate-700 mt-2 whitespace-pre-wrap leading-relaxed">{r.message}</p>
        </div>
      ))}
    </div>
  );
}
